import { CityFeedback } from './CityFeedback';
import { CityServices } from './CityServices';
import { CityExperience } from './CityExperience';
import { CityOverview } from './CityOverview';
import { MapPin, MessageCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { citySlug } from '../../lib/citySlug';
import { Link } from 'react-router-dom';

export const CityDetail = ({ city, handleWhatsAppClick }) => (
<div 
                  data-testid={`city-detail-${citySlug(city)}`}
                  id={citySlug(city)}
                  className="city-detail bg-gradient-to-br from-gray-900/90 to-black/90 p-6 md:p-8 rounded-2xl border-2 border-red-900/40 hover:border-red-600/60 transition-all"
                >
                  <h3 className="text-2xl md:text-3xl font-bold text-red-500 mb-4 flex items-center">
                    <MapPin className="w-8 h-8 mr-3 text-red-600" />
                    Marabout Africain {city} - Retour Affectif Rapide {city}
                  </h3>
                  
                  <div className="space-y-4 text-gray-300 leading-relaxed">
                    <CityOverview city={city} />
                    
                    <CityExperience city={city} />
                    
                    <CityServices city={city} />
                    
                    <CityFeedback city={city} />
                    
                    <p className="text-base md:text-lg">
                      <strong className="text-yellow-400">Prix et Tarifs à {city}</strong> : Maître Diamma pratique des tarifs honnêtes et transparents 
                      pour ses consultations à {city}. Première consultation gratuite pour évaluer votre situation. 
                      Devis personnalisé selon la complexité du cas. Paiement après résultats pour certains rituels. 
                      Pas de frais cachés. Le <strong className="text-white">marabout Maître Diamma à {city}</strong> privilégie 
                      la satisfaction client avant tout.
                    </p>
                    
                    <Link data-testid={`city-page-link-${citySlug(city)}`} to={`/marabout/${citySlug(city)}`} className="inline-block text-yellow-400 underline underline-offset-4">
                      Marabout à {city}
                    </Link>
                    <Button 
                      data-testid={`city-whatsapp-${citySlug(city)}`}
                      onClick={handleWhatsAppClick}
                      className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-semibold text-base md:text-lg py-5 md:py-6 flex items-center justify-center mt-4"
                    >
                      <MessageCircle className="w-5 h-5 mr-2 flex-shrink-0" />
                      <span>WhatsApp - Marabout {city}</span>
                    </Button>
                  </div>
                </div>
);
